<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-card class="login" flat style="border-radius: 10px" color="white">
              <span class="login-title">
                <img src="https://static.wixstatic.com/media/2eea8b_208c7c0e5f3c4b8bb54be278779091f9~mv2.png" width="100%" style="max-width: 200px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <!-- QUESTIONÁRIO GERAL -->
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-card dark style="background: #586a6a" flat>
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6 mx-auto no-break">Feedback Geral</v-card-title>
                            <v-card-subtitle>
                              Participe da nossa pesquisa de satisfação geral e ajude a melhorar os serviços oferecidos pelo Hospital Napoleão Laureano.
                            </v-card-subtitle>
                            <v-card-actions>
                              <router-link :to="'/questionarios?q=671b894c961e123a5692dbc1'" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Responder</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <!-- QUESTIONÁRIO OUVIDORIA -->
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-card dark style="background: #586a6a" flat>
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6 mx-auto no-break">Feedback Ouvidoria</v-card-title>
                            <v-card-subtitle>
                              Dê a sua opinião na pesquisa de satisfação da ouvidoria e contribua para aprimorar o atendimento e a comunicação com nossos pacientes.
                            </v-card-subtitle>
                            <v-card-actions>
                              <router-link :to="'/questionarios?q=671b844b961e123a5692db1b'" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Responder</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <!-- <img src="../../assets/LogoBrancoHorizontal.png" width="150px"> -->
          </a>
        </div>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  // import { baseApiUrl } from '@/global'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { mapState } from 'vuex'
  // import axios from 'axios'
  export default {
    components: {
      Loading
    },

    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        empresa: [],
      }
    },

    mounted: function () {
      //
    },

    methods: {
      //
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #586a6a, #586a6a);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>